export default "__VITE_ASSET__D9zTV9YQ__"